/**
  * Get SAILS object for GigaCube repo
*/
const getGigacubeObject = () => window.GigaCube;

/**
  * Get SAILS object property for Gigacube repo by 'key'
*/
export const getGigacubeObjectProperty = (key: string) => getGigacubeObject()?.[key];

/**
  * Set SAILS object property for Gigacube repo by 'key' and 'value'
*/
export const setGigacubeObjectProperty = (key: string, value: any) => {
    if (!window.GigaCube) {
        window.GigaCube = {};
    }

    window.GigaCube[key] = value;
};
